import React, { useContext } from 'react';
import cn from 'classnames';
import { getDataTestId } from '../../../../shared/esm';
import { ModalContext } from '../../Context.js';
import { ResponsiveContext } from '../../ResponsiveContext.js';
import '../../../../base-modal/esm';

var styles = {"content":"side-panel__content_d9clb","withHeader":"side-panel__withHeader_d9clb","flex":"side-panel__flex_d9clb"};
require('./index.css');

var Content = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, dataTestId = _a.dataTestId;
    var _c = useContext(ModalContext), contentRef = _c.contentRef, hasHeader = _c.hasHeader;
    var responsiveContext = useContext(ResponsiveContext);
    return (React.createElement("div", { className: cn(styles.content, className, styles.flex, (_b = {},
            _b[styles.withHeader] = hasHeader,
            _b)), ref: contentRef, "data-test-id": dataTestId || getDataTestId(responsiveContext === null || responsiveContext === void 0 ? void 0 : responsiveContext.dataTestId, 'content') }, children));
};

export { Content };
